import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import AstraScene from './three/AstraScene';
import CanvasErrorBoundary from './three/CanvasErrorBoundary';
import Header from './components/Header';
import Hero from './components/Hero';
import Sections from './components/Sections';
import Footer from './components/Footer';
import HUD from './components/HUD';
import EasterEggGame from './components/EasterEggGame';

export default function App() {
  const [progress, setProgress] = useState(0);
  const rafId = useRef();

  useEffect(() => {
    const tick = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const p = max > 0 ? h.scrollTop / max : 0;
      setProgress(p);
      rafId.current = requestAnimationFrame(tick);
    };
    rafId.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafId.current);
  }, []);

  // IntersectionObserver for reveal-on-scroll
  useEffect(() => {
    const els = document.querySelectorAll('.reveal');
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="App grain vignette scanlines">
      <CanvasErrorBoundary>
        <AstraScene />
      </CanvasErrorBoundary>
      <HUD progress={progress} />
      <div className="content-layer">
        <Header progress={progress} />
        <Hero />
        <Sections />
        <Footer />
      </div>
      <EasterEggGame />
    </div>
  );
}
